import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { WaterMeterModel } from "@/core/models/water-meter.model";

interface _WaterMeterGetParams {
    search?: string;
    status?: string;
    createdBy?: string;
    waterUserId?: string;
}

@injectable()
export class WaterMeterRepo extends TableRepo<WaterMeterModel> {
    constructor() {
        super("/api/WaterMeter");
    }

    async getData(index: number, params: _WaterMeterGetParams, pageSize = 10): Promise<ApiPage<WaterMeterModel>|null> {
        return await super.getData(index, params, pageSize);
    }

}